export let dp_direction = {
    //là on met un commentaire qui indique de quelle entreprise il s'agit: Card
    CARD:{//id de l'entreprise
        Master:'CardMaster',//le master doit obligatoirement être renseigné. Nom du composant Master
        TabTicket:'erp/CardTabTicket',
        CompteurBassin:'pos/CardCompteurBassin'
    },
    INTE:{//id de l'entreprise
        Master:'InterdisMaster',//le master doit obligatoirement être renseigné. Nom du composant Master
        ModePayment:'pos/InterdisModePayment',
        Comptabilite:'erp/InterdiCompta',
        RemboursementOther:'pos/InterdisRefundOther'
    },
    CGL:{//id de l'entreprise
        Master:'MinisoMaster',//le master doit obligatoirement être renseigné. Nom du composant Master
        Comptabilite:'erp/MinisoCompta',
    },
    CAD:{//id de l'entreprise
        Master:'CdimMaster',//le master doit obligatoirement être renseigné. Nom du composant Master
        CaisseForm:'pos/CdimCaisseForm',
        Close:'pos/CdimClose',
        CdimCustomMadeItemModal:'pos/CdimCustomMadeItemModal'
    },
    SANDI:{//id de l'entreprise /!!! Atnetion ici on a repris les dev de Cadrimages !!!/
        Master:'CdimMaster',//le master doit obligatoirement être renseigné. Nom du composant Master
        CaisseForm:'pos/CdimCaisseForm',
        Close:'pos/CdimClose',
        CdimCustomMadeItemModal:'pos/CdimCustomMadeItemModal'
    },
    PVIN:{//id de l'entreprise /!!! Atnetion ici on a repris les dev de Cadrimages !!!/
        Master:'CdimMaster',//le master doit obligatoirement être renseigné. Nom du composant Master
        CaisseForm:'pos/CdimCaisseForm'
    },
    MIOT:{//id de l'entreprise /!!! Atnetion ici on a repris les dev de Cadrimages !!!/
        Master:'CdimMaster',//le master doit obligatoirement être renseigné. Nom du composant Master
        CaisseForm:'pos/CdimCaisseForm'
    },
    FREEM:{//id de l'entreprise
        Master:'FreemanMaster',//le master doit obligatoirement être renseigné. Nom du composant Master
        GiftAvoir:'pos/GiftAvoir'
    },
}